import { render } from "./MainStat.vue?vue&type=template&id=767b66c2"
import script from "./MainStat.vue?vue&type=script&lang=js"
export * from "./MainStat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__